'use client';
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Facebook;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
function Facebook(props = {}) {
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { inheritViewBox: true, children: (0, jsx_runtime_1.jsx)("svg", { viewBox: "0 0 320 512", children: (0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" }) }) }));
}
